import { node, string } from 'prop-types';
import React from 'react';

const DetailsContainer = ({ children }) => {
	return <section className="trend-data-container body-content bg-white">{children}</section>;
};

DetailsContainer.propTypes = {
	children: node.isRequired,
	className: string
};

export default DetailsContainer;
